export default __webpack_public_path__ + "maps-examples-heatmap-example-960-b579c48ce310a1e5277a0943f65df04c.webp";